import type { PlannerMeshId } from '@/views/3d-planner/scene/plannerObjectId';
import type { VisibilityToggles } from '@/views/3d-planner/measurements/visibilityToggles';
import { crossSectionIds } from '@/views/3d-planner/scene/crossSection';
import { none } from 'ramda';

export function isMeshVisible(visibility: VisibilityToggles, plannerId: PlannerMeshId): boolean {
    switch (plannerId) {
        case 'metal':
            return true;
        case 'cup-collision-surface':
            return false;
        case 'bearing':
        case 'cup':
        case 'liner':
        case 'stem':
        case 'head':
            return visibility.implant === 'on';
        case 'cup-coverage':
            return visibility.implant === 'on' && visibility.xray === 'on'
                && none(id => visibility[id] === 'on', crossSectionIds);
        case 'operative-femur':
        case 'operative-femur-internal':
        case 'contralateral-femur':
            return visibility.femur === 'on';
        case 'sacrum':
        case 'operative-hemipelvis':
        case 'contralateral-hemipelvis':
            return visibility.pelvis === 'on';
    }
}
